export const CardTypes = {
  DEFAULT: 'default',
  SIMPLE: 'simple',
  SR: 'streaming-reward',
  SRCONCIERGE: 'streaming-reward-concierge',
};

export const ViewTypes = {
  DEFAULT: 'default',
  SR: 'streaming-reward',
};

export const BundleCardTypes = {
  LINK: 'link',
  MODAL: 'modal',
};

export default { CardTypes, BundleCardTypes };
